import { createTemplateTag } from '../Tag'
import { extractValueWithPath } from '../ResolveValue'

export const props = createTemplateTag('props', (path, context) => {
  return extractValueWithPath(context.props, path)
})

export const string = createTemplateTag('string', (path) => {
  return path
})
